export default __webpack_public_path__ + "static/media/insurance.445d0cfb.svg";